import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { 
    SiteVisitationSteps, useSiteVisitation } from "../../../providers/SiteVisitationProvider";
import {
  GetAvailableMachinesForReplaceType,
  GetLocationsType,
  replaceMachine,
} from "../../../models/_publicCall";
import { GetMachineServiceType } from "../../../models/_tickets";
import toast from "react-hot-toast";

const ReplaceMachine = (props: {
  values: any;
  handleChange: any;
  setFieldValue: any;
  machineServicesDB: GetMachineServiceType[];
  machinesDB: GetAvailableMachinesForReplaceType[];
  locationsDB: GetLocationsType[];
  setCurrentStep: (step: number) => void;
  selectedMachine: any;
  jobId:any
}) => {
  const {
    jobId,
    machinesDB,
    locationsDB,
    selectedMachine,
    setCurrentStep
  } = props;

  const { setSelectedMachine, updateMachineData, selectedMachineDetails, refetchMachineList } = useSiteVisitation();
  const machineIdRefs = useRef<{ [machineId: string]: any }>({});
  const [error, setError] = useState<string | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
    useEffect(() => {
      if (!selectedMachine?.id) return;
      setSelectedMachine(selectedMachine.id, jobId);
    }, [selectedMachine, jobId]);

  const handleReplaceMachine = async () => {
    setIsSubmitted(true);
    if (selectedMachineDetails?.replaceMachine && !selectedMachineDetails.newMachineId) {
      setError("Please Select New Machine");
      setIsSubmitted(false)
      return;
    }

    if (selectedMachineDetails.replaceMachine && !selectedMachineDetails.oldMachineShiftToLocationId) {
      setError("Please Select Location to shift old machine");
      setIsSubmitted(false)
      return;
    }

    setError(null);

    try {
      const machineData:any = {
        currentMachineId:selectedMachineDetails.id,
        newMachineId: selectedMachineDetails.newMachineId || null,
        oldMachineShiftToLocationId: selectedMachineDetails.oldMachineShiftToLocationId,
        convertToLabTicket: selectedMachineDetails.convertToLabTicket || false,
      };
      const response= await replaceMachine(jobId, machineData); // Call the API
      if(response?.isSuccess) {
        toast.success("Machine Replace successfully");
        refetchMachineList(jobId);
        setCurrentStep(SiteVisitationSteps.MACHINE_LIST); // Navigate to the machine list step
        setIsSubmitted(false);
      } else {
        toast.error("Failed to Replace Machine");
        setIsSubmitted(false);
      }
    } catch (error) {
      setError("Failed to replace machine. Please try again.");
      setIsSubmitted(false);
    }
  };

  return (
    <div className="wo-form-section mt-8">
      <header className="header">
        <h2>Replace Machine</h2>
      </header>
     
      <div className="flex justify-between items-center m-4">
        <div className="left-icon mt-4" onClick={() => setCurrentStep(SiteVisitationSteps.TICKET_INFO)}>
          <i className="fa fa-arrow-left" aria-hidden="true"></i>
        </div>
      </div>

      <div className="machine-wrapper">
        <div className="mb-4 text-sm font-medium">
          <p>
            <strong>Machine Name:</strong> {selectedMachine?.name || "N/A"}
          </p>
        </div>
        <div className="mb-4 mt-4">
          <label className="form-check form-check-custom form-check-solid me-5 d-flex align-items-center">
            <input
              id="replaceMachine"
              type="checkbox"
              name="replaceMachine"
              className="form-check-input"
              checked={selectedMachineDetails.replaceMachine || false}
              onChange={(e) => {
                updateMachineData(jobId,selectedMachine.id,"replaceMachine", e.target.checked);
              }}
            />
            <span className="wo-label mt-2 ms-3 fs-5" style={{ cursor: "pointer" }}>
              Replace Machine
            </span>
          </label>
        </div>
        <div className="mb-4">
          <label className="wo-label required fs-5">New Machine</label>
          <Select
            className="react-select"
            classNamePrefix="my-react-select"
            name="machineId"
            placeholder="Please select new machine"
            ref={(el: any) => (machineIdRefs.current[selectedMachine?.id] = el)}
            options={machinesDB
              .filter((record) => record.id !== selectedMachine?.id)
              .map((value: any) => ({
                value: value.id,
                label: `${value.machine_name || value.location_name || ""} ${value.serial_number}`,
              }))}
            onChange={(e: any) => {
              updateMachineData(jobId,selectedMachine.id,"newMachineId", e.value);
            }}
            value={
              selectedMachineDetails.newMachineId
                ? machinesDB.find((m) => m.id === selectedMachineDetails.newMachineId)?.id && {
                    value: selectedMachineDetails.newMachineId,
                    label: machinesDB.find((m) => m.id === selectedMachineDetails.newMachineId)?.serial_number,
                  }
                : null
            }
            isDisabled={!selectedMachineDetails.replaceMachine}
          />
        </div>

        <div className="mb-4 mt-4">
          <label className="wo-label fs-5">Where you want to shift old machine?</label>
          <Select
            className="react-select"
            classNamePrefix="my-react-select"
            name="oldMachineShiftToLocationId"
            placeholder=""
            options={locationsDB.map((value: any) => ({
              value: value.id,
              label: value.name,
            }))}
            onChange={(e: any) => {
              updateMachineData(jobId,selectedMachine.id,"oldMachineShiftToLocationId", e.value);
            }}
            value={
              selectedMachineDetails.oldMachineShiftToLocationId
                ? locationsDB.find((l) => l.id === selectedMachineDetails.oldMachineShiftToLocationId)?.id && {
                    value: selectedMachineDetails.oldMachineShiftToLocationId,
                    label: locationsDB.find((l) => l.id === selectedMachineDetails.oldMachineShiftToLocationId)?.name,
                  }
                : null
            }
            isDisabled={!selectedMachineDetails.replaceMachine}
          />
        </div>

        <div className="mb-4 mt-4">
          <label className="form-check form-check-custom form-check-solid me-5 d-flex align-items-center">
            <input
              id="convertToLabTicket"
              type="checkbox"
              name="convertToLabTicket"
              className="form-check-input"
              checked={selectedMachineDetails.convertToLabTicket || false}
              onChange={(e) => {
                updateMachineData(jobId,selectedMachine.id,"convertToLabTicket", e.target.checked);
              }}
              disabled={!selectedMachineDetails.replaceMachine}
            />
            <span className="wo-label mt-2 ms-3 fs-5" style={{ cursor: "pointer" }}>
              Do you want to convert all open tickets to lab ticket?
            </span>
          </label>
        </div>

        {error && (
          <div className="text-danger mt-2">
            {error}
          </div>
        )}
        <button
          className="btn btn-primary float-end"
          type="button"
          onClick={handleReplaceMachine}
          disabled={isSubmitted}
        >
          {isSubmitted ? "Replacing..." : <>Replace Machine
          <i className="fa fa-check-circle ms-2" aria-hidden="true"></i></>}
        </button>
      </div>
    </div>
  );
};

export default ReplaceMachine;
